// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d6d5e1ce","453":"77d31088","455":"f9cc390b","977":"c695b3f3"}[chunkId] + ".chunk.js";
};